import { isNone, isEmpty } from '@ember/utils';

function notProvided(value: string) {
  return isNone(value) || isEmpty(value.trim());
}

export interface AccountAddressFormValues {
  addressLine1: string;
  addressLine2: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
}

export default {
  addressLine1(value: string) {
    return notProvided(value) ? "Please enter your company's address" : true;
  },
  city(value: string) {
    return notProvided(value) ? "Please enter your company's city" : true;
  },
  state: {
    dependentKeys: ['country'],
    validator(value: string, model: AccountAddressFormValues) {
      if (model.country === 'United States') {
        return notProvided(value) ? "Please enter your company's state" : true;
      }

      return true;
    },
  },
  country: {
    dependentKeys: ['state'],
    validator(value: string) {
      return notProvided(value) ? "Please enter your company's country" : true;
    },
  },
  zipCode(value: string) {
    return notProvided(value) ? "Please enter your company's zip code" : true;
  },
};
